import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

// =========================
// 1) CREATE / UPDATE BULK
// =========================
export const createOrUpdateInventoryData = createAsyncThunk(
    "inventory/createOrUpdateInventoryData",
    async (inventoryArray, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.post(`${BackendURL}/inventorydata`, inventoryArray, {
                withCredentials: true,
            });
            return res.data; // array of results
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// =========================
// 2) FETCH BY CREATEDBY
// =========================
export const getInventoryByCreatedBy = createAsyncThunk(
    "inventory/getInventoryByCreatedBy",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(`${BackendURL}/inventorydata/get-data`, {
                withCredentials: true,
            });
            console.log("res.data.inventoryData", res);
            return res.data.inventoryData; // array of inventory items

        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// =========================
// 3) DELETE BY ID
// =========================
export const deleteInventoryData = createAsyncThunk(
    "inventory/deleteInventoryData",
    async (_id, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.delete(`${BackendURL}/inventorydata/delete/${_id}`, {
                withCredentials: true,
            });
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// =======================================================
// SLICE
// =======================================================
const inventorySlice = createSlice({
    name: "inventory",
    initialState: {
        items: [],
        loading: false,
        error: null,
        successMessage: null,
    },

    reducers: {
        clearInventoryMessages(state) {
            state.error = null;
            state.successMessage = null;
        },
    },

    extraReducers: (builder) => {
        builder

            // ===============================
            // CREATE / UPDATE MULTIPLE
            // ===============================
            .addCase(createOrUpdateInventoryData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createOrUpdateInventoryData.fulfilled, (state, action) => {
                state.loading = false;
                state.successMessage = "Inventory saved successfully";
            })
            .addCase(createOrUpdateInventoryData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // ===============================
            // FETCH BY CREATEDBY
            // ===============================
            .addCase(getInventoryByCreatedBy.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getInventoryByCreatedBy.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(getInventoryByCreatedBy.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // ===============================
            // DELETE BY ID
            // ===============================
            .addCase(deleteInventoryData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteInventoryData.fulfilled, (state, action) => {
                state.loading = false;
                state.items = state.items.filter((x) => x._id !== action.payload);
                state.successMessage = "Inventory deleted successfully";
            })
            .addCase(deleteInventoryData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearInventoryMessages } = inventorySlice.actions;

export default inventorySlice.reducer;
